module.exports = __webpack_public_path__ + "static/coding-emails-mobile-96fd80997a2376ec5e05e058ff143dde.jpg";